import Doughnut from "libs/preact-chart/Doughnut";
import ChartCard from "components/Chart/ChartCard";

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    title: {
      display: true,
      text: "Plazo de pago",
      font: {
        size: 24,
      },
    },
  },
};

function ChartPaymentTerm(props) {
  if (!props.data) return;
  const labels = props.data?.map((item) => item.payment_term);
  const values = props.data?.map((item) => item.untaxed_amount);

  const dataset = [
    {
      label: "Valor",
      data: values,
      backgroundColor: ["#d9f99d", "#bae6fd"],
      borderColor: ["#84cc16", "rgba(150, 150, 150, 1)"],
      borderWidth: 1,
    },
  ];

  return (
    <ChartCard style="pb-8">
      <div className="chart-segment-container">
        <Doughnut
          refName={"payment_term"}
          labels={labels}
          dataSet={dataset}
          height={285}
          options={options}
        />
      </div>
    </ChartCard>
  );
}

export default ChartPaymentTerm;
